import React, { useState } from "react";
import LoginPage from "./LoginPage";
import SignupPage from "./SignupPage";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import cc_img from "../../img/banners/cc-img_wp.avif";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import websiteLogo from "../../img/parts/Cycle-Circle-Logo-Orange-1.png";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";
import { toggleOverlay } from "../../store/slices/headerSlice";
import { setPhoneNumber } from "../../store/slices/userSlice";
import { connect } from "react-redux";
import { useLocation } from "react-router-dom";

function AuthenticationPage({ toggleOverlay }) {
  const [tab, setTab] = useState("login");
  const location = useLocation();
  const isRootPath = location.pathname === "/";

  const handleTabChange = (mode) => setTab(mode);
  

  const AuthCard = (
    <div className="relative max-w-[400px] w-full bg-black-1 bg-opacity-85 rounded-[20px] text-white-1 p-4">
      <div
        className="absolute top-2 right-2 cursor-pointer"
        onClick={() => {
          toggleOverlay();
          setPhoneNumber(null);
        }}
      >
        <CloseSharpIcon />
      </div>
      <div className="flex justify-center mb-4 border-b border-gray-600">
        <button
          className={`px-4 py-2 ${
            tab === "login" ? "text-gold border-b-2 border-gold" : "text-white"
          }`}
          onClick={() => handleTabChange("login")}
        >
          Login
        </button>
        <button
          className={`px-4 py-2 ${
            tab === "signup" ? "text-gold border-b-2 border-gold" : "text-white"
          }`}
          onClick={() => handleTabChange("signup")}
        >
          Sign Up
        </button>
      </div>
      {tab === "login" && <LoginPage />}
      {tab === "signup" && <SignupPage handleTabChange={handleTabChange} />}
    </div>
  );

  if (isRootPath) {
    return (
      <div className="relative w-screen h-screen flex items-center justify-between">
        {/* Background image */}
        <div className="absolute bg-white-1 top-0 left-0 w-full h-full -z-10">
          <img
            src={cc_img}
            alt="bg-img"
            className="w-full h-screen object-cover"
          />
        </div>

        {/* Logo */}
        <div className="absolute top-5 left-5">
          <LazyLoadImage
            src={websiteLogo}
            alt="Logo"
            effect="blur"
            className="w-[90px] h-auto"
            wrapperProps={{ style: { transitionDelay: "1s" } }}
          />
        </div>

        {/* Auth card */}
        <div className="flex w-full h-full items-center justify-center md:justify-end md:pr-16">
          {AuthCard}
        </div>
      </div>
    );
  }

  // When URL is not "/"
  return (
    <div className="flex justify-center items-center w-full h-full p-4">
      {AuthCard}
    </div>
  );
}

const mapStateToProps = (state) => ({
  user: state.user,
});

const mapDispatchToProps = {
  setPhoneNumber,
  toggleOverlay,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationPage);
